'use client';

import React, { useState } from 'react';
import AppLayout from '@/components/layout/AppLayout';
import DashboardKpiRow from './components/DashboardKpiRow';
import DashboardRequisitionsTable from './components/DashboardRequisitionsTable';
import DashboardWaepChart from './components/DashboardWaepChart';
import SectionTitle from '@/components/ui/SectionTitle';
import { RefreshCw } from 'lucide-react';
import { useCountry } from '@/context/CountryContext';
import { useLanguage } from '@/context/LanguageContext';

export default function DashboardPage() {
  const [lastUpdated] = useState('24 Jul 2026, 03:14 WAT');
  const { profile } = useCountry();
  const { t } = useLanguage();

  return (
    <AppLayout
      title={`${profile?.ministry} - ${t('page.dashboardTitle')}`}
      subtitle={`${profile?.utility} ${t('page.dashboardSub')}`}
    >
      {/* Last updated bar */}
      <div className="flex items-center gap-2 mb-5 text-xs text-text-muted">
        <RefreshCw size={12} className="text-status-green" />
        <span>
          {t('action.lastRefreshed')}:{' '}
          <span className="font-medium text-text-main">{lastUpdated}</span>
        </span>
        <span
          className="w-1.5 h-1.5 rounded-full bg-status-green animate-pulse inline-block ml-1"
        />
        <span className="text-status-green font-medium">{t('action.live')}</span>
      </div>
      {/* KPI Cards */}
      <DashboardKpiRow />
      {/* Content Grid */}
      <div className="grid grid-cols-1 xl:grid-cols-5 gap-6 mt-6">
        {/* Recent Requisitions */}
        <div className="xl:col-span-3 bg-surface-card rounded-xl border border-surface-border shadow-card p-5">
          <SectionTitle
            title={t('section.recentRequisitions')}
            subtitle={t('section.recentRequisitionsSub')}
            action={
              <a
                href="/requisitions"
                className="text-xs font-medium transition-colors hover:underline"
                style={{ color: 'var(--accent)' }}
              >
                {t('action.viewAll')} →
              </a>
            }
          />
          <DashboardRequisitionsTable />
        </div>

        {/* WAEP Electrification Chart */}
        <div className="xl:col-span-2 bg-surface-card rounded-xl border border-surface-border shadow-card p-5">
          <SectionTitle
            title={t('section.waepAccess')}
            subtitle={t('section.waepAccessSub')}
          />
          <DashboardWaepChart />
        </div>
      </div>
    </AppLayout>
  );
}